import React from 'react';

import { Builder, BuilderPagerControls, EditorContainer, EmptyContentPlaceholder } from '../layout/Builder.jsx';
import { default as Image } from '../common/Image.jsx';
import Name from '../common/Name.jsx';
import Parallax from '../common/Parallax.jsx'

function ParallaxComponent(props) {
    const data = props.blockConfig && props.blockConfig.slides;
    if (!data || data.length == 0) {
        if (props.builder) {
            return (
                <>
                    <BuilderPagerControls disabled={true} onBlockMove={props.onBlockMove} />
                    <EmptyContentPlaceholder>This parallax doesn't have any content yet, but you can manage this under the Content section.</EmptyContentPlaceholder>
                </>
            )
        }
        return null;
    }
    const [activeSlide, setActiveSlide] = React.useState(undefined);
    const handlePageChange = (direction) => {
        switch (direction) {
            case 'next':
                if (data && activeSlide + 1 < data.length) {
                    setActiveSlide(activeSlide + 1);
                }
                break;
            case 'prev':
                if (data && activeSlide - 1 >= 0) {
                    setActiveSlide(activeSlide - 1);
                }
                break;
        }
    }
    React.useEffect(() => {
        if (!props.builder) {
            return;
        }
        setActiveSlide(0);
    }, []);
    return (
        <>
            {
                props.builder &&
                <BuilderPagerControls onBlockMove={props.onBlockMove} onPageChange={handlePageChange} />
            }
            <Parallax.Container.Component {...props} activeSlide={activeSlide} backgroundStyle={{ backgroundSize: 'contain' }} data={data} pageData={props.data} slideComponent={ParallaxCellContainer} />
        </>
    )
}

function ParallaxCellContainer(props) {
    let contentConfig = props.contentConfig;
    if (!contentConfig) {
        if (props.data && props.data.parallaxContent) {
            contentConfig = props.data.parallaxContent;
        } else {
            contentConfig = {};
        }
    }
    let blocks = [];
    if (contentConfig.desktop && contentConfig.desktop.blocks) {
        blocks = contentConfig.desktop && contentConfig.desktop.blocks;
    }
    let containerStyle = { height: props.height };
    let handleBuilderBlockProps;
    if (props.builder) {
        handleBuilderBlockProps = (d, blockConfig, parentProps) => {
            const blockProps = Builder.handleBlockProps(d, blockConfig, parentProps) || {};
            if (!d.type) {
                return blockProps;
            }
            switch (d.type.value) {
                case Name.Block.Columns:
                    if (d.config && d.config.layout && d.config.layout.minHeight && d.config.layout.minHeight.value && d.config.layout.minHeight.value.length > 0) {
                        if (!blockProps.style) {
                            blockProps.style = {};
                        }
                        blockProps.style.height = `${d.config.layout.minHeight.value}${d.config.layout.minHeight.unit}`;
                    }
                    break;
            }
            return blockProps;
        }
        if (!props.editor) {
            containerStyle.pointerEvents = 'none';
        } else if (props.data && props.data.image) {
            const backgroundProps = Parallax.Utilities.parseBackgroundProps(props.data);
            containerStyle = backgroundProps.style;
            containerStyle.height = props.height;
            if (props.imageSize) {
                containerStyle.backgroundImage = `url(${Image.url(props.data.image, props.imageSize, props.imageSize)})`
            }
        }
    }
    const handleContent = (content, style) => {
        let link, newWindow;
        if (props.data) {
            if (props.data.href && props.data.href.length > 0) {
                link = props.data.href;
            }
            newWindow = props.data.newWindow;
        }
        const contentClassName = 'parallax__content';
        if (!link || props.editor) {
            return <div className={contentClassName} style={style}>{content}</div>
        } else if (link) {
            return <a className={contentClassName} href={link} style={style} target={newWindow ? '_blank' : undefined}>{content}</a>
        }
        return content;
    }
    const handleBlockProps = (d) => {
        if (!d.type) {
            return;
        }
        const blockProps = props.blockPropsHandler && props.blockPropsHandler() || {};
        switch (d.type.value) {
            case Name.Block.PageTitleV1:
                blockProps.pageData = props.pageData;
                break;
        }
        return blockProps;
    }
    return (
        <EditorContainer
            {...props}
            blockPropsHandler={handleBlockProps}
            blocks={blocks}
            builderBlockPropsHandler={handleBuilderBlockProps}
            className="parallax__slide cell--whitelabel cell--whitelabel--parallax"
            containerProps={contentConfig.desktop && contentConfig.desktop.page}
            inCell={true}
            style={containerStyle}
            updateBackgroundColor={false}
            onContainerProps={props.onPageProps}
            onContent={handleContent} />
    );
}

export default { Cell: ParallaxCellContainer, Component: ParallaxComponent };